/*
 * @Descripttion: 请假信息表 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-04-09
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-13 21:50:20
 */

import http from '@/utils/kq/http';

const veStuLeaveApi = {
  //添加接口
  add(data) {
    return http.post(http.service.stu + 'veStuLeave/add', data);
  },
  //删除接口
  delete(ids) {
    return http.delete(http.service.stu + 'veStuLeave/deleteBatch?ids=' + ids);
  },
  //修改接口
  update(data) {
    return http.put(http.service.stu + 'veStuLeave/edit', data);
  },
  //分页查询接口
  page(pageData) {
    return http.post(http.service.stu + 'veStuLeave/page', pageData);
  },
  //查询单个数据接口
  get(id) {
    return http.get(http.service.stu + 'veStuLeave/queryById', { id: id });
  },
  //更新状态
  updateStatus(data) {
    return http.post(http.service.stu + 'veStuLeave/updateStatus', data);
  },
  //更新状态
  audit(data) {
    return http.post(http.service.stu + 'veStuLeave/audit', data);
  }
};
export default veStuLeaveApi;
